{
  "ascending": "tõusev järjestus",
  "ascendingSort": "sorditud veeru järgi {columnName} tõusvas järjestuses",
  "columnSize": "{value} pikslit",
  "descending": "laskuv järjestus",
  "descendingSort": "sorditud veeru järgi {columnName} laskuvas järjestuses",
  "resizerDescription": "Suuruse muutmise alustamiseks vajutage klahvi Enter",
  "select": "Vali",
  "selectAll": "Vali kõik",
  "sortable": "sorditav veerg",
  "collapse": "Ahenda",
  "expand": "Laienda"
}
